import onClick from "@/js/libs/onClick";

let APP = window.APP || {};

const scrollToElement = function (element, offset) {
  let scrollElement;

  if (typeof element === "string") {
    scrollElement = document.querySelector(element);
  }

  if (scrollElement) {
    let t = scrollElement.getBoundingClientRect().top;
    window.scrollTo(0, window.pageYOffset + t + offset);
  }
};

function getCoords(elem) {
  let box = elem.getBoundingClientRect();
  let body = document.body;
  let docEl = document.documentElement;
  let scrollTop = window.pageYOffset || docEl.scrollTop || body.scrollTop;
  let scrollLeft = window.pageXOffset || docEl.scrollLeft || body.scrollLeft;
  let clientTop = docEl.clientTop || body.clientTop || 0;
  let clientLeft = docEl.clientLeft || body.clientLeft || 0;
  let top = box.top + scrollTop - clientTop;
  let left = box.left + scrollLeft - clientLeft;

  return {
    top: Math.round(top),
    left: Math.round(left),
  };
}

document.addEventListener("DOMContentLoaded", () => {
  let header = document.querySelector(".Header, .HeaderLegacy");
  let max = 200;
  let min = 0;
  let fadeInAt = 200;
  let fadeClass = "fadeIn";
  APP.scrollHeaderTicking = false;
  let lastScrollY = window.pageYOffset;
  let totalMovement = 0;
  let supportsPassive = false;
  let _locked = false;
  let stickyEl = document.querySelector(".sticky");
  let stickyCalc = false;
  let calBase = 120;
  let stickyLinksVisible = false;

  let _setBase = function () {
    if (APP.media.matches("tablet-below")) {
      max = 166;
      calBase = 70;
    } else if (APP.media.matches("desktop")) {
      max = 278;
      fadeInAt = 268;
      calBase = 100;
    } else {
      max = 200;
      calBase = 100;
    }

    if (stickyEl) {
      let doTransform =
        APP.media.matches("laptop") ||
        stickyEl.classList.contains("sticky--calendar");

      stickyCalc = {
        doTransform: doTransform,
        element: stickyEl,
        aboveViewport: false,
        parentElement: stickyEl.parentElement,
        parent: getCoords(stickyEl.parentElement), // is teh container of the .sticky
      };
    }
  };

  window.addEventListener("resize.end", _setBase);

  _setBase();

  let limit = function (n) {
    return Math.min(max, Math.max(min, n));
  };

  let addClass = function () {
    header.classList.add(fadeClass);
  };

  let removeClass = function () {
    header.classList.remove(fadeClass);
  };

  let setY = function (y) {
    header.style.transform = "translateY(" + y + "px)";

    if (stickyCalc) {
      if (
        stickyCalc.parent.top + 20 < window.pageYOffset &&
        !stickyCalc.aboveViewport
      ) {
        stickyCalc.aboveViewport = true;
        stickyCalc.parentElement.classList.remove("js-aboveViewport");
      }

      if (
        stickyCalc.parent.top > window.pageYOffset &&
        stickyCalc.aboveViewport
      ) {
        stickyCalc.aboveViewport = false;
        stickyCalc.parentElement.classList.add("js-aboveViewport");
      }

      let t;
      if (stickyCalc.aboveViewport && stickyCalc.doTransform) {
        t = "translateY(" + (y + calBase) + "px)";
      } else {
        t = "translateY(" + "0" + "px)";
      }

      stickyCalc.element.style.transform = t;
      stickyCalc.element.style.webkitTransform = t;
      stickyCalc.element.style.msTransform = t;
    }

    window.dispatchEvent(new CustomEvent('sticky-nav-y', {
      detail: { y, stickyCalc }
    }));
  };

  //Make out like they scrolled down, resetting the values
  let reset = function () {
    _locked = true;
    setY(0);
  };

  if (window.location.hash) {
    reset();
    scrollToElement(window.location.hash, -60);

    setTimeout(function () {
      reset();
      scrollToElement(window.location.hash, -60);
    }, 1);
  }

  onClick("a", (e) => {
    let id = e.target.getAttribute("data-cal-anchor");
    if (!id) {
      return true;
    }
    window.location.hash = "#" + id;
    if (window.location.href != e.target.href) {
      return true;
    }

    scrollToElement("#" + id, -60);
    e.preventDefault();
    reset();
  });

  let paint = function () {
    let offset = -0.5 * totalMovement;

    // While the sticky links bar is showing (laptop+), keep the menu fully
    // hidden so it doesn't drop down over the links on a backward scroll.
    if (stickyLinksVisible && APP.media.matches("laptop")) {
      offset = -0.5 * max;
    }

    setY(offset);

    if (lastScrollY > fadeInAt) {
      addClass();
    } else {
      removeClass();
    }
  };

  try {
    let opts = Object.defineProperty({}, "passive", {
      get: function () {
        return (supportsPassive = true);
      },
    });
    window.addEventListener("test", null, opts);
  } catch (e) {
    console.error(e);
  }

  APP.resetHeaderTicking = function () {
    APP.scrollHeaderTicking = false;
  };

  var update = function () {
    if (APP.locked) {
      return;
    }
    paint();
    APP.scrollHeaderTicking = false;
  };

  var requestTick = function () {
    if (!APP.scrollHeaderTicking) {
      requestAnimationFrame(update);
      APP.scrollHeaderTicking = true;
    }
  };

  var _onscroll = function () {
    if (_locked) {
      setTimeout(function () {
        _locked = false;
      }, 100);
      return;
    }

    totalMovement = limit(totalMovement + (window.pageYOffset - lastScrollY));
    // Don't let it go under 0
    lastScrollY = Math.max(0, window.pageYOffset);
    requestTick();
  };

  APP.resetStickyHeader = function () {
    totalMovement = 0;
    removeClass();
    setY(0);
  };

  APP.hideStickyHeader = function () {
    totalMovement = max;
    paint();
  };

  document.addEventListener(
    "scroll",
    _onscroll,
    supportsPassive ? { passive: true } : false,
  );

  window.addEventListener(
    "sidebar",
    paint,
    supportsPassive ? { passive: true } : false,
  );

  window.addEventListener("sticky-links-visible", (e) => {
    stickyLinksVisible = e.detail;
    paint();
  });
});
